import * as i0 from '@angular/core';
import { Directive, Inject, NgModule } from '@angular/core';
import { TuiFocusVisibleService, TuiDestroyService } from '@taiga-ui/cdk/services';
import * as i1 from 'rxjs';

/**
 * Directive to imitate :focus-visible
 * (https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-visible)
 * in browsers that do not support it
 */
class TuiFocusVisibleDirective {
    constructor(tuiFocusVisibleChange) {
        this.tuiFocusVisibleChange = tuiFocusVisibleChange;
    }
}
TuiFocusVisibleDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiFocusVisibleDirective, deps: [{ token: TuiFocusVisibleService }], target: i0.ɵɵFactoryTarget.Directive });
TuiFocusVisibleDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.17", type: TuiFocusVisibleDirective, selector: "[tuiFocusVisibleChange]", outputs: { tuiFocusVisibleChange: "tuiFocusVisibleChange" }, providers: [TuiDestroyService, TuiFocusVisibleService], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiFocusVisibleDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[tuiFocusVisibleChange]',
                    outputs: ['tuiFocusVisibleChange'],
                    providers: [TuiDestroyService, TuiFocusVisibleService],
                }]
        }], ctorParameters: function () { return [{ type: i1.Observable, decorators: [{
                    type: Inject,
                    args: [TuiFocusVisibleService]
                }] }]; } });

class TuiFocusVisibleModule {
}
TuiFocusVisibleModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiFocusVisibleModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TuiFocusVisibleModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiFocusVisibleModule, declarations: [TuiFocusVisibleDirective], exports: [TuiFocusVisibleDirective] });
TuiFocusVisibleModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiFocusVisibleModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiFocusVisibleModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TuiFocusVisibleDirective],
                    exports: [TuiFocusVisibleDirective],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TuiFocusVisibleDirective, TuiFocusVisibleModule };
